import React, {useEffect} from "react";
import globalMasehtot from "../../masehtot.json";
import Spinner from "../../../spinner";


const PrintMasehtot = ({siumStatus, usersList, pagesWereTaken, pagesWereLearned, sium, back}) => {

    const logoList = {
        'hamesh-esre': '/hameshEsre.png',
        'yacahdBeorcha': '/yacahdBeorcha.png',
        'mehinotToraniot': '/mehinotToraniot.png',
        'chabad': '/chabad.png',
        'uriel': '/uriel.png'
    };

    useEffect(() => {
        if (!siumStatus) return;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setTimeout(() => {
            window.print();
        }, 1500);
    }, [siumStatus]);

    if (!sium || !sium.kehilaName || !globalMasehtot.allMasehtot || !siumStatus) {
        return (<Spinner/>);
    }

    const today = new Date();
    const endD = sium.endSium?.toDate();
    const daysNum = endD ? Math.round((endD - today) / (24 * 60 * 60 * 1000)) : null;
    const logoImg = sium.logo && logoList[sium.logo] ? logoList[sium.logo] : null;

    const takenPercent = Math.floor((pagesWereTaken / sium.pagesCounter) * 100);
    const learnedPercent = Math.floor((pagesWereLearned / sium.pagesCounter) * 100);

    // Process masehtot data
    const masehtotData = Object.entries(siumStatus)
        .sort(([, a], [, b]) => a.masehetIndex - b.masehetIndex)
        .map(([masehetKey, masehet]) => {
            const currentMasehet = globalMasehtot.allMasehtot[masehetKey];
            const totalChapters = masehet.totalChapters;
            const takenChapters = masehet.chapters.filter((chapter) => chapter.user).length;
            const learnedChapters = masehet.chapters.filter((chapter) => chapter.wasLearned).length;
            const allTaken = totalChapters === takenChapters;
            const allLearned = totalChapters === learnedChapters;

            // Get unique learners for this masehet
            const learners = masehet.usersList?.map(userId => usersList[userId]?.name).filter(Boolean) || [];

            return {
                key: masehetKey,
                name: currentMasehet.name,
                isMishna: currentMasehet.isMishna,
                totalChapters,
                takenChapters,
                learnedChapters,
                allTaken,
                allLearned,
                learners,
                percent: totalChapters > 0 ? Math.floor((learnedChapters / totalChapters) * 100) : 0
            };
        });

    masehtotData.forEach(masehet => {
        masehet.learners.forEach(learnerName => {
            console.log({ [masehet.name]: learnerName });
        });
    });

    return (
        <div className="print-page">
            {/* No-print back button */}
            <div className="no-print print-back-btn">
                <button className="btn sium-button return-button" onClick={() => back(false)}>חזור</button>
            </div>

            {/* Header */}
            <div className="print-header">
                <div className="print-header-right">
                    <span className="print-basad">בס"ד</span>
                </div>
                <div className="print-header-center">
                    <h1 className="print-title">סיום הש"ס של {sium.kehilaName}</h1>
                    {sium.nishmat && <p className="print-nishmat">{sium.nishmat}</p>}
                </div>
                <div className="print-header-left">
                    {logoImg && <img src={logoImg} alt="logo" className="print-logo-img" />}
                </div>
            </div>

            {/* Progress Summary */}
            <div className="print-summary">
                <div className="print-summary-item">
                    <span className="print-summary-label">נלקחו:</span>
                    <span className="print-summary-value">{takenPercent}%</span>
                    <div className="print-progress-bar">
                        <div className="print-progress-fill taken" style={{width: `${takenPercent}%`}}></div>
                    </div>
                </div>
                <div className="print-summary-item">
                    <span className="print-summary-label">נלמדו:</span>
                    <span className="print-summary-value">{learnedPercent}%</span>
                    <div className="print-progress-bar">
                        <div className="print-progress-fill learned" style={{width: `${learnedPercent}%`}}></div>
                    </div>
                </div>
                {daysNum !== null && daysNum > 0 && (
                    <div className="print-summary-item days">
                        <span>נותרו {daysNum} ימים</span>
                    </div>
                )}
            </div>

            {/* Masehtot Grid */}
            <div className="print-masehtot-grid">
                {masehtotData.map((masehet) => (
                    <div
                        key={masehet.key}
                        className={`print-masehet-item ${masehet.allLearned ? 'completed' : masehet.allTaken ? 'taken' : masehet.takenChapters > 0 ? 'partial' : 'empty'}`}
                    >
                        <div className="print-masehet-header">
                            <span className="print-masehet-name">{masehet.name}</span>
                            {masehet.isMishna && <span className="print-mishna-badge">מ</span>}
                            <span className="print-masehet-status">
                                {masehet.allLearned ? '✓' : `${masehet.learnedChapters}/${masehet.totalChapters}`}
                            </span>
                        </div>
                        {masehet.learners.length > 0 && (
                            <div className="print-masehet-learners">
                                {masehet.learners.slice(0, 3).join(', ')}
                                {masehet.learners.length > 3 && ` (+${masehet.learners.length - 3})`}
                            </div>
                        )}
                    </div>
                ))}
            </div>

            {/* Legend */}
            <div className="print-legend">
                <div className="print-legend-item">
                    <span className="print-legend-box completed"></span>
                    <span>נלמד</span>
                </div>
                <div className="print-legend-item">
                    <span className="print-legend-box taken"></span>
                    <span>נלקח</span>
                </div>
                <div className="print-legend-item">
                    <span className="print-legend-box partial"></span>
                    <span>חלקי</span>
                </div>
                <div className="print-legend-item">
                    <span className="print-legend-box empty"></span>
                    <span>פנוי</span>
                </div>
                <div className="print-legend-item">
                    <span className="print-mishna-badge">מ</span>
                    <span>משנה</span>
                </div>
            </div>

            {/* Learners Summary Table */}
            <div className="print-learners-section">
                <h3 className="print-section-title">רשימת לומדים ({Object.keys(usersList).length})</h3>
                <div className="print-learners-table">
                    {Object.entries(usersList)
                        .sort(([, a], [, b]) => a.name.localeCompare(b.name, 'he'))
                        .map(([userId, user]) => {
                            const learnedCount = user.userPagesLearned || 0;
                            const totalCount = user.userPagesTaken || 0;
                            const userPercent = totalCount > 0 ? Math.floor((learnedCount / totalCount) * 100) : 0;
                            const isComplete = learnedCount === totalCount && totalCount > 0;

                            return (
                                <div key={userId} className={`print-learner-row ${isComplete ? 'complete' : ''}`}>
                                    <span className="print-learner-name">{user.name}</span>
                                    <span className="print-learner-progress">
                                        {isComplete ? '✓' : `${userPercent}%`}
                                    </span>
                                </div>
                            );
                        })}
                </div>
            </div>

            {/* Footer */}
            <div className="print-footer">
                <span>© כל הזכויות שמורות לאתר סיום הש"ס | siumshas.co.il</span>
            </div>
        </div>
    );
};

export default PrintMasehtot;
